import React, { useState } from 'react';
import { Card, Row, Col, Tab, Nav } from 'react-bootstrap';
import './About.css';

const About = () => {
  const [activeTab, setActiveTab] = useState('mission');

  return (
    <div className="admin-about-page">
      {/* Page Header */}
      <div className="page-header">
        <div className="page-header-content">
          <div>
            <h2 className="page-title">
              <i className="fa fa-info-circle me-3"></i>
              À propos de SenOffre
            </h2>
            <p className="page-subtitle">
              Gérer et personnaliser les informations de votre plateforme
            </p>
          </div>
        </div>
      </div>

      {/* Stats Cards */}
      <Row className="mb-4">
        <Col xl={3} lg={6} sm={6}>
          <Card className="stat-card stat-card-primary">
            <Card.Body>
              <div className="stat-icon">
                <i className="fa fa-briefcase"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">10,000+</h3>
                <p className="stat-label">Appels d'offres</p>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col xl={3} lg={6} sm={6}>
          <Card className="stat-card stat-card-success">
            <Card.Body>
              <div className="stat-icon">
                <i className="fa fa-building"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">500+</h3>
                <p className="stat-label">Entreprises</p>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col xl={3} lg={6} sm={6}>
          <Card className="stat-card stat-card-warning">
            <Card.Body>
              <div className="stat-icon">
                <i className="fa fa-user-tie"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">50,000+</h3>
                <p className="stat-label">Candidats</p>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col xl={3} lg={6} sm={6}>
          <Card className="stat-card stat-card-info">
            <Card.Body>
              <div className="stat-icon">
                <i className="fa fa-handshake"></i>
              </div>
              <div className="stat-content">
                <h3 className="stat-number">5,000+</h3>
                <p className="stat-label">Recrutements</p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Main Content with Tabs */}
      <Card className="about-content-card">
        <Card.Body>
          <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
            <Nav variant="pills" className="about-tabs mb-4">
              <Nav.Item>
                <Nav.Link eventKey="mission">
                  <i className="fa fa-bullseye me-2"></i>
                  Mission
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="values">
                  <i className="fa fa-star me-2"></i>
                  Valeurs
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="team">
                  <i className="fa fa-users me-2"></i>
                  Équipe
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="features">
                  <i className="fa fa-rocket me-2"></i>
                  Fonctionnalités
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content>
              {/* Mission Tab */}
              <Tab.Pane eventKey="mission">
                <div className="tab-content-wrapper">
                  <div className="content-header">
                    <h3 className="content-title">Notre Mission</h3>
                    <p className="content-subtitle">
                      Transformer le marché des Appels d'offres au Sénégal
                    </p>
                  </div>
                  
                  <Row>
                    <Col lg={6}>
                      <div className="mission-text">
                        <p className="lead-text">
                          SenOffre est née de la volonté de révolutionner la recherche d'Appels d'offres au Sénégal. 
                          Notre plateforme connecte les talents locaux avec les entreprises qui recherchent 
                          les meilleurs profils, créant ainsi un écosystème professionnel dynamique et inclusif.
                        </p>
                        <p>
                          Nous croyons que chaque personne mérite d'accéder aux opportunités qui correspondent 
                          à ses compétences et à ses aspirations. C'est pourquoi nous avons créé une plateforme 
                          intuitive, moderne et accessible à tous.
                        </p>
                      </div>
                    </Col>
                    <Col lg={6}>
                      <div className="mission-cards">
                        <div className="feature-card">
                          <div className="feature-icon">
                            <i className="fa fa-rocket"></i>
                          </div>
                          <h4>Innovation</h4>
                          <p>Technologie de pointe pour une expérience utilisateur optimale</p>
                        </div>
                        <div className="feature-card">
                          <div className="feature-icon">
                            <i className="fa fa-users"></i>
                          </div>
                          <h4>Communauté</h4>
                          <p>Créer des connexions authentiques entre talents et entreprises</p>
                        </div>
                        <div className="feature-card">
                          <div className="feature-icon">
                            <i className="fa fa-chart-line"></i>
                          </div>
                          <h4>Croissance</h4>
                          <p>Accompagner le développement professionnel de chacun</p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Tab.Pane>

              {/* Values Tab */}
              <Tab.Pane eventKey="values">
                <div className="tab-content-wrapper">
                  <div className="content-header">
                    <h3 className="content-title">Nos Valeurs</h3>
                    <p className="content-subtitle">
                      Ce qui nous guide au quotidien
                    </p>
                  </div>
                  
                  <Row>
                    <Col lg={6} className="mb-4">
                      <div className="value-card">
                        <div className="value-icon-wrapper">
                          <i className="fa fa-shield-alt"></i>
                        </div>
                        <h4>Transparence</h4>
                        <p>
                          Nous croyons en une communication claire et honnête avec nos utilisateurs, 
                          candidats comme recruteurs.
                        </p>
                      </div>
                    </Col>
                    <Col lg={6} className="mb-4">
                      <div className="value-card">
                        <div className="value-icon-wrapper">
                          <i className="fa fa-star"></i>
                        </div>
                        <h4>Excellence</h4>
                        <p>
                          Nous nous engageons à fournir un service de qualité supérieure et à améliorer 
                          continuellement notre plateforme.
                        </p>
                      </div>
                    </Col>
                    <Col lg={6} className="mb-4">
                      <div className="value-card">
                        <div className="value-icon-wrapper">
                          <i className="fa fa-heart"></i>
                        </div>
                        <h4>Inclusion</h4>
                        <p>
                          Nous valorisons la diversité et œuvrons pour un marché des Appels d'offres accessible à tous, 
                          sans discrimination.
                        </p>
                      </div>
                    </Col>
                    <Col lg={6} className="mb-4">
                      <div className="value-card">
                        <div className="value-icon-wrapper">
                          <i className="fa fa-lightbulb"></i>
                        </div>
                        <h4>Innovation</h4>
                        <p>
                          Nous adoptons les dernières technologies pour offrir une expérience moderne 
                          et efficace à nos utilisateurs.
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Tab.Pane>

              {/* Team Tab */}
              <Tab.Pane eventKey="team">
                <div className="tab-content-wrapper">
                  <div className="content-header">
                    <h3 className="content-title">Notre Équipe</h3>
                    <p className="content-subtitle">
                      Des experts passionnés à votre service
                    </p>
                  </div>
                  
                  <Row>
                    <Col lg={4} className="mb-4">
                      <div className="team-card">
                        <div className="team-avatar">
                          <i className="fa fa-laptop-code"></i>
                        </div>
                        <h4>Équipe Technique</h4>
                        <p className="team-role">Développement & Innovation</p>
                        <p className="team-description">
                          Experts en développement web et mobile, garantissant une plateforme 
                          performante et sécurisée.
                        </p>
                      </div>
                    </Col>
                    <Col lg={4} className="mb-4">
                      <div className="team-card">
                        <div className="team-avatar">
                          <i className="fa fa-headset"></i>
                        </div>
                        <h4>Équipe Support</h4>
                        <p className="team-role">Assistance & Accompagnement</p>
                        <p className="team-description">
                          Disponibles pour répondre à vos questions et vous accompagner dans 
                          l'utilisation de la plateforme.
                        </p>
                      </div>
                    </Col>
                    <Col lg={4} className="mb-4">
                      <div className="team-card">
                        <div className="team-avatar">
                          <i className="fa fa-user-friends"></i>
                        </div>
                        <h4>Équipe RH</h4>
                        <p className="team-role">Recrutement & Partenariats</p>
                        <p className="team-description">
                          Spécialistes en ressources humaines travaillant avec les entreprises 
                          pour des recrutements de qualité.
                        </p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Tab.Pane>

              {/* Features Tab */}
              <Tab.Pane eventKey="features">
                <div className="tab-content-wrapper">
                  <div className="content-header">
                    <h3 className="content-title">Fonctionnalités Principales</h3>
                    <p className="content-subtitle">
                      Ce qui rend SenOffre unique
                    </p>
                  </div>
                  
                  <Row>
                    <Col lg={6} className="mb-4">
                      <div className="feature-item">
                        <div className="feature-number">01</div>
                        <div className="feature-content">
                          <h4>Recherche Intelligente</h4>
                          <p>
                            Algorithme de matching avancé pour connecter les bons candidats 
                            aux bonnes opportunités.
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col lg={6} className="mb-4">
                      <div className="feature-item">
                        <div className="feature-number">02</div>
                        <div className="feature-content">
                          <h4>Gestion Simplifiée</h4>
                          <p>
                            Interface intuitive pour gérer facilement vos annonces, candidatures 
                            et communications.
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col lg={6} className="mb-4">
                      <div className="feature-item">
                        <div className="feature-number">03</div>
                        <div className="feature-content">
                          <h4>Sécurité Renforcée</h4>
                          <p>
                            Protection des données personnelles et professionnelles avec les 
                            derniers standards de sécurité.
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col lg={6} className="mb-4">
                      <div className="feature-item">
                        <div className="feature-number">04</div>
                        <div className="feature-content">
                          <h4>Support 24/7</h4>
                          <p>
                            Équipe de support disponible pour vous accompagner à tout moment 
                            dans votre parcours.
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </Card.Body>
      </Card>
    </div>
  );
};

export default About;
